/** @format */
import { css } from 'styled-components';

const baseStyles = css`
    width: 100%;
    margin-bottom: var(--layout-spacing-12);

    .search-filter {
        margin: 0;
    }
`;

export const styles = () => css`
    ${baseStyles}
`;
